import { post } from "@/utils/utils";
// 导购相关接口
const goodsDepositGoodsDetails = {
  state: {},
  mutations: {
    QUERY_PAGE_LIST() {},
    ADD_SENDER_MSG() {},
    SENDER_MSG_PAGE_LIST_QUERY() {},
    EDIT_SENDER_MSG_URL() {},
    DELETE_SENDER_MSG_URL() {},
    QUERY_RECEIVING_FORMFIELD_INFO() {},
    SAVE_STORE_RECEIVING_FORM_FIELD_INFO() {}
  },
  actions: {
    addSenderMsg({ commit }, params) {
      return post({
        commit,
        url: `/store/storeReceivingSenderInfo/saveStoreReceivingSenderInfo`,
        name: "ADD_SENDER_MSG",
        params
      })
    },
    queryGoodsDetailsPageList({ commit }, params) {
      return post({
        commit,
        url: `/deposit/take/records`,
        name: "QUERY_PAGE_LIST",
        params
      });
    },
    senderMsgPageListQuery({ commit }, params) {
      return post({
        commit,
        url: `/store/storeReceivingSenderInfo/queryStoreReceivingSenderInfoList`,
        name: "SENDER_MSG_PAGE_LIST_QUERY",
        params
      });
    },
    editSenderMsgUrl({ commit }, params) {
      return post({
        commit,
        url: `/store/storeReceivingSenderInfo/editStoreReceivingSenderInfo`,
        name: "EDIT_SENDER_MSG_URL",
        params
      });
    },
    deleteSenderMsgUrl({ commit }, params) {
      return post({
        commit,
        url: `/store/storeReceivingSenderInfo/removeStoreReceivingSender`,
        name: "DELETE_SENDER_MSG_URL",
        params
      });
    },
    queryReceivingFormFieldInfo({ commit }, params) {
      return post({
        commit,
        url: `/store/storeReceivingSenderInfo/queryReceivingFormFieldInfo`,
        name: "QUERY_RECEIVING_FORMFIELD_INFO",
        params
      });
    },
    saveStoreReceivingFormFieldInfo({ commit }, params) {
      return post({
        commit,
        url: `/store/storeReceivingSenderInfo/saveStoreReceivingFormFieldInfo`,
        name: "SAVE_STORE_RECEIVING_FORM_FIELD_INFO",
        params
      });
    },
  }
};

export default goodsDepositGoodsDetails;
